import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import HeadshotComponent from '../../conversations/components/headshot';
import Subthread from './subthread';
import RepliesStates from '../types/replies_states';
import ShowRepliesButton from './show_replies_button';
import MessageCreatorContainer from '../containers/message_creator_container';
import ShowMoreRepliesButton from './show_more_replies_button';
import moment from 'moment';

const Message = ({ message, currentUser, conversationId, childMessages, insertMessage, togglMessageCreator, messageCreatorVisible }) => {
  let focusable;
  if (message.focus) {
    focusable = useRef(null);

    useEffect(() => {
      $(focusable.current).focus();
    }, []);

  }

  childMessages = childMessages.filter(child => child.parentId === message.id)
  const childRepliesCount = childMessages.length;

  const [incrementChildRepliesShowCount, setIncrementChildRepliesShowCount] = useState(3);
  const [childRepliesState, setChildRepliesState] = useState(RepliesStates.HIDDEN);

  useEffect(() => {
    if (childRepliesState === RepliesStates.HIDDEN) {
      setIncrementChildRepliesShowCount(3)
    }

  }, [childRepliesState])

  const showNextFiveChildReplies = () => {
    setChildRepliesState(RepliesStates.SHOW_INCREMENT_AMOUNT);
    let nextAmount = incrementChildRepliesShowCount === 3 ? 2 : 5;
    setIncrementChildRepliesShowCount(incrementChildRepliesShowCount + nextAmount);
  }

  const handleReplyVisibility = () => {
    if (messageCreatorVisible) {
      togglMessageCreator(null);
    } else {
      togglMessageCreator(message.id);
    }
  }

  const closeReplyCreator = () => {
    togglMessageCreator(null);
  }

  const showNewReply = () => {
    if (childRepliesState === RepliesStates.HIDDEN) {
      setChildRepliesState(RepliesStates.FIRST_ONE);
    }
  }


  const {
    creator,
    createdAt,
    tags
  } = message;

  const focusProps = message.focus ? {
    className: 'message focused',
    ref: focusable,
    tabIndex: 0
  } : {}

  return (
    <div className="message" {...focusProps}>
      <HeadshotComponent user={creator} />

      <div className="message-right">
        <p className="t5 w3 message-name">
          <a className="text-black" key={creator.id} href={creator.profileLink}>{creator.displayName}</a>

          <small className="t6 dark-gray text-default message-time pull-right" title={createdAt}>
            {moment(createdAt).fromNow()}
          </small>
        </p>

        <small className="t6 dark-gray line-clamp-2" title={creator.companyTitle}>{creator.companyTitle.replace(' at ', ', ')}</small>

        <div className="message-main">
          <div className="message-header mb-5"></div>

          <div className="t5 content"
            dangerouslySetInnerHTML={{ __html: message.body }}>
          </div>
        </div>
      </div>
      <div className="subthread message-actions">
        <a className="mr-20" onClick={() => handleReplyVisibility()}>Reply</a>
        <ShowRepliesButton
          repliesCount={childRepliesCount}
          repliesState={childRepliesState}
          handleRepliesState={setChildRepliesState}
          subthread={true} />
      </div>
      <Subthread
        subthreads={childMessages}
        incrementChildRepliesShowCount={incrementChildRepliesShowCount}
        repliesState={childRepliesState} />
      <ShowMoreRepliesButton rowlength={childRepliesCount} count={incrementChildRepliesShowCount} state={childRepliesState} incrementCallback={showNextFiveChildReplies} subthread={true} />
      {messageCreatorVisible && (
        <MessageCreatorContainer
          className="subthread"
          closeReplyCreator={closeReplyCreator}
          conversationId={conversationId}
          currentUser={currentUser}
          persistMessageCallback={insertMessage}
          showNewReply={showNewReply}
          parentId={message.id} />
      )
      }
    </div>
  );
};

Message.propTypes = {
  message: PropTypes.object.isRequired
};

export default Message;
